<!-- =========================================================================================
    File Name: GridColumnsHandler.vue
    Description: Save Column State for Grid
    ----------------------------------------------------------------------------------------
      Author: Faruk Nikmorad
      Auth DATE: 09062020
========================================================================================== -->

<template>
  <!-- CART DROPDOWN -->
  <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">
      <feather-icon icon="CheckSquareIcon" class="cursor-pointer ml-4 mr-6 mt-1"  />
      <vs-dropdown-menu class="cart-dropdown vx-navbar-dropdown dropdown-custom" >

          <!-- IF CART HAVE ITEMS: HEADER -->
          <template >
              <div class="notification-header text-center p-5 bg-primary text-white">
                  <h3 class="text-white"> Columns List</h3>
              </div>
          </template>
          <vs-input class="sm: mt-2 ml-4 mr-4 sm:w-auto w-full sm:order-normal sm: mt-4" v-model="searchClient" placeholder="Search..." />
          <component :is="scrollbarTag" ref="mainSidebarPs" class="scroll-area--cart-items-dropdowm p-0 mb-10 mt-4" :settings="settings" :key="$vs.rtl">
            <li
              v-for="item in colData"
              :key="item.name"
              class="sm: mt-3 ml-5 mr-5 vx-row no-gutter cart-item cursor-pointer">
              <vs-checkbox :disabled="item.lock" color="success" v-model="item.visible">{{item.name}}</vs-checkbox>
            </li>
          </component>
              <div
                class=" checkout-footer fixed bottom-0 rounded-b-lg text-primary font-semibold w-full p-2 text-center border border-b-0 border-l-0 border-r-0 border-solid d-theme-border-grey-light cursor-pointer">
                <!-- @click="$router.push('/apps/eCommerce/checkout').catch(() => {})"> -->

                <!-- <span class="flex items-center justify-center">
                  <feather-icon icon="ShoppingCartIcon" svgClasses="h-4 w-4" />
                  <span class="ml-2">Checkout</span>
                </span> -->

              </div>
      </vs-dropdown-menu>
  </vs-dropdown>
</template>


<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'

export default {
  components: {
    VuePerfectScrollbar
  },
  props: {
    data: {
      type: Array,
      required: false
    }
  },
  data () {
    return {
      data_local: this.data,
      searchClient : null,

      settings: { // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: .60
      }
    }
  },
  computed:{
    colData () {
      return this.data_local.filter(data => {
        return !this.searchClient || data.name.toLowerCase().includes(this.searchClient.toLowerCase()) > 0 
      })
    },
    scrollbarTag () {
      return this.$store.getters.scrollbarTag
    }
  }
}
</script>
